import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["input", "error", "value"]

  connect() {
    if (this.hasValueTarget) {
      this.defaultLabel = this.valueTarget.textContent.trim()
    }
    this.validate()
  }

  validate() {
    const fileInput = this.inputTarget
    if (!fileInput) return

    fileInput.addEventListener('change', (event) => {
      this.validateFile(event.target.files[0])
    })
  }

  checkFileType(event) {
    this.validateFile(event.target.files[0])
  }

  validateFile(file) {
    if (this.hasValueTarget) {
      this.valueTarget.textContent = file ? file.name : (this.defaultLabel || this.valueTarget.textContent)
    }

    if (!file) {
      this.hideError()
      return true
    }

    const maxSizeMb = parseInt(this.inputTarget?.dataset?.maxSizeMb || '10', 10)
    const maxSize = maxSizeMb * 1024 * 1024

    const rawAccept = this.inputTarget.getAttribute('accept')
    const accept = (rawAccept && rawAccept.trim()) ? rawAccept.toLowerCase() : ''
    const isPdfAccept = accept && accept.includes('application/pdf')

    if (isPdfAccept) {
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
      if (!isPdf) {
        this.showError('Bitte wählen Sie eine PDF-Datei aus.')
        this.clearInput()
        return false
      }
    }

    if (file.size > maxSize) {
      this.showError(`Die Datei ist zu groß. Maximale Größe: ${maxSizeMb} MB`)
      this.clearInput()
      return false
    }

    this.hideError()
    return true
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    }
    try {
      this.inputTarget.classList.add('border-red-500', 'focus:ring-red-600', 'focus:border-red-600')
    } catch (e) {}
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
    try {
      this.inputTarget.classList.remove('border-red-500', 'focus:ring-red-600', 'focus:border-red-600')
    } catch (e) {}
  }

  clearInput() {
    if (this.inputTarget) this.inputTarget.value = ''
    if (this.hasValueTarget) {
      this.valueTarget.textContent = this.defaultLabel || ''
    }
  }
}
